export const onOpen = async (opts, userContext) => {
  if (!opts.isNewConversation) {
    if (!window?.sierra) {
      window?.newrelic?.noticeError(
        new Error("window.sierra is unavailable"),
        {}
      );
    }

    await window.sierra?.updateSecrets({
      accessToken: userContext?.accessToken,
    });

    await window.sierra?.updateVariables({
      customerId: userContext?.customerId,
      isAuthenticated: userContext?.isAuthenticated,
      firstName: userContext?.firstName,
      lastName: userContext?.lastName,
    });

    if (userContext?.isAuthenticated) {
      window.sierra?.sendUserAttachment([
        {
          type: "custom",
          data: {
            type: "user-logged-in",
          },
        },
      ]);
    }
  }
};
